import { styled } from '@mui/material';
import appTheme from 'App.theme';
import { Color } from 'components/Button/Button.model';
import { colors } from 'components/Colors';

import { IInlineLoader } from '../InlineLoader';

const firstCirclePalette = {
  primary: appTheme.palette.primary.main,
  secondary: appTheme.palette.secondary.main,
  success: appTheme.palette.success.main,
  warning: appTheme.palette.warning.main,
  error: appTheme.palette.error.main,
  info: appTheme.palette.info.main,
  inherit: appTheme.palette.common.white
};

const secondCirclePalette = {
  primary: appTheme.palette.info.main,
  secondary: colors.common.grey.value,
  success: appTheme.palette.info.light,
  warning: colors.orange.grey.value,
  error: colors.red.grey.value,
  info: appTheme.palette.info.light,
  inherit: appTheme.palette.info.main
};

export const InlineLoaderWrapper = styled('div')<IInlineLoader>`
  .MuiBox-root {
    position: relative;
    & > :first-of-type {
      color: ${({ variant, color, theme }) =>
        variant === 'contained'
          ? theme.palette.common.white
          : firstCirclePalette[color as Color]};
    }
    & > :last-child {
      position: absolute;
      left: 0;
      color: ${({ color }) => secondCirclePalette[color as Color]};
    }
  }
`;
